// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".lad-facebook-widget{text-align:center}.lad-facebook-widget .fb-group{width:100%}.lad-facebook-widget .fb-group>span{display:block;margin:0 auto}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
